import type {FC} from 'react'
import {useEffect, useState} from 'react'
import Image from 'next/image'
import {emptyImagePlaceholder} from 'constants/image'
import {Button, Grid, Link} from 'components/ui'
import {ROUTE_SELLER_INDEX} from 'routes/sellers'
import {slugify} from 'helpers/slugfy'
import {MapMarker, UserCircle} from 'components/icons'
import {SellerProfileProps} from '.'
import s from './seller-profile.module.css'

const DESCRIPTION_LENGTH = 280

const SellerProfile: FC<SellerProfileProps> = ({seller, className = '', withHeader = true, onlyInfo = false}) => {
  const [crop, setCrop] = useState<boolean>(false)
  const {name, avatar, header, description, responsible, delivery} = seller

  useEffect(() => {
    setCrop(!!(description && description?.length > DESCRIPTION_LENGTH))
  }, [description])
  return (
    <div className={s.root}>
      {withHeader && (
        <>
          <div className={s.header}>
            <img src={(header && (header?.url as string)) || emptyImagePlaceholder} alt={name} />
          </div>
          <Link href={`${ROUTE_SELLER_INDEX}/${slugify(name)}`} className={className}>
            <div className={s.titleHeader}>{name}</div>
          </Link>
        </>
      )}

      {onlyInfo && (
        <div className={s.content}>
          <Grid.Row>
            <div className={s.avatar}>
              <Image
                src={(avatar && (avatar?.url as string)) || emptyImagePlaceholder}
                alt={name}
                width="160px"
                height="160px"
              />
            </div>
            <div className={s.info}>
              <Link href={`${ROUTE_SELLER_INDEX}/${slugify(name)}`} className={className}>
                <div className={s.title}>{name}</div>
              </Link>
              <div className={s.description}>
                {crop ? `${description?.substr(0, DESCRIPTION_LENGTH)}...` : description}
                <div className={s.crop}>
                  {description && description?.length > DESCRIPTION_LENGTH && (
                    <Button onClick={() => setCrop(!crop)} variant="text">
                      Mostrar {crop ? 'mais' : 'menos'}
                    </Button>
                  )}
                </div>
              </div>
              <div className={s.items}>
                <Grid.Row>
                  <Grid.Column className={s.item}>
                    <MapMarker/>
                    <span>{delivery}</span>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className={s.item}>
                    <UserCircle/>
                    <span>{responsible}</span>
                  </Grid.Column>
                </Grid.Row>
              </div>
            </div>
          </Grid.Row>
        </div>
      )}
    </div>
  )
}

export default SellerProfile
